import api from '@/api/api_alerta'
import Vue from 'vue'
import { asyncLoading } from 'vuejs-loading-plugin'
import VueLoading from 'vuejs-loading-plugin'


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Carregando', // default 'Loading'
    loading: false, // default false
    background: 'rgba(10,23,55,0.7)', // set custom background
})

export default {
  BUSCARPLACAALERTA ({ commit }, {codUsuario, cidade, placa}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscarPlacaAlerta(codUsuario, cidade, placa)
        commit("BUSCARPLACAALERTA", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  CADASTRARALERTA ({ commit }, {usuario, cidade, alerta}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.cadastrarAlerta(usuario, cidade, alerta)
        commit("CADASTRARALERTA", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  ALTERARALERTA ({ commit }, {codOcorrencia, usuario, cidade, alerta}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.alterarAlerta(codOcorrencia, usuario, cidade, alerta)
        commit("ALTERARALERTA", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  DELETARALERTA ({ commit }, {codigoUsuario, cidade, codigoAlerta}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.deletarAlerta(codigoUsuario, cidade, codigoAlerta)
        commit("DELETARALERTA", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  BUSCARALERTAS ({ commit }, {codigoUsuario, cidade}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscarAlertas(codigoUsuario, cidade)
        commit("BUSCARALERTAS", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
}